/**
 * @module FE-CU42_緊急連絡先設定_変更モーダル画面
 */
export default {
  name: 'EditContactModal',
  props: [
    'contact',
    'error',
    'valid',
    'dialog',
    'rules',
    'appendAlertClass',
    'toggleModal',
    'sortFlag',
  ],
  data() {
    return {
      childDialog: this.dialog,
      childContact: { ...this.contact },
      childValid: this.valid,
      contactCopy: { ...this.contact },
    };
  },
  watch: {
    childDialog(isOpened) {
      if (!isOpened) {
        this.childContact = { ...this.contactCopy };
      }
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * キャンセルボタン押下時処理
     */
    closeDialog() {
      this.childContact = { ...this.contactCopy };
      let self = this;
      let contactCopyKeys = Object.keys(this.contactCopy);
      contactCopyKeys.forEach(function (key) {
        self.$set(self.childContact, key, self.contactCopy[key]);
      });
      this.childDialog = false;
    },
    /**
     * 登録ボタン押下時処理
     */
    editContact() {
      if (this.$refs.form.validate()) {
        this.$emit('edit-contact', this.childContact);
        this.closeDialog();
      }
    },
  },
  computed: {
    disabled() {
      if (
        !this.childContact.name ||
        !this.childContact.nameKana ||
        !this.childContact.relationship ||
        !this.childContact.phoneNumber ||
        !this.childValid
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
